import { Link } from 'react-router-dom'
import { ArrowLeft, X, Users } from 'lucide-react'
import { formatName, resolveImg } from '@/lib/helpers'
import Avatar from '@/components/ui/Avatar'

export type FollowUser = {
  _id: string
  fullName: string
  avatar?: string
  bio?: string
  role?: string
}

export type ModalType = 'followers' | 'following' | null

type Props = {
  type: ModalType
  users: FollowUser[]
  onClose: () => void
}

export default function FollowModal({ type, users, onClose }: Props) {
  if (!type) return null

  const title = type === 'followers' ? 'Дагагчид' : 'Дагаж буй'

  return (
    <div
      className="fixed inset-0 z-50 flex items-center justify-center"
      onClick={(e) => e.target === e.currentTarget && onClose()}
    >
      {/* Backdrop */}
      <div className="absolute inset-0 bg-black/40 backdrop-blur-sm" onClick={onClose} />

      {/* Modal */}
      <div className="relative z-10 w-full max-w-md mx-4 bg-white rounded-2xl shadow-2xl overflow-hidden">
        {/* Header */}
        <div className="flex items-center justify-between px-5 py-4 border-b border-gray-100">
          <div className="flex items-center gap-2">
            <Users className="size-4 text-gray-400" />
            <h2 className="font-semibold text-gray-900">{title}</h2>
            <span className="text-sm text-gray-400">({users.length})</span>
          </div>
          <button
            onClick={onClose}
            className="p-1.5 rounded-lg text-gray-400 hover:text-gray-600 hover:bg-gray-100 transition-colors"
          >
            <X className="size-4" />
          </button>
        </div>

        {/* List */}
        <div className="overflow-y-auto max-h-[60vh] divide-y divide-gray-50">
          {users.length === 0 ? (
            <div className="py-12 text-center text-sm text-gray-400">
              {type === 'followers' ? 'Дагагч байхгүй байна' : 'Дагаж буй хүн байхгүй байна'}
            </div>
          ) : (
            users.map((u) => (
              <Link
                key={u._id}
                to={u.role === 'teacher' ? `/teachers/${u._id}` : `/profile/${u._id}`}
                onClick={onClose}
                className="flex items-center gap-3 px-5 py-3.5 hover:bg-gray-50 transition-colors group"
              >
                <Avatar
                  src={resolveImg(u.avatar)}
                  alt={formatName(u.fullName)}
                  size="sm"
                />
                <div className="flex-1 min-w-0">
                  <p className="text-sm font-medium text-gray-900 group-hover:text-blue-600 transition-colors truncate">
                    {formatName(u.fullName)}
                  </p>
                  {u.bio && (
                    <p className="text-xs text-gray-400 truncate mt-0.5">{u.bio}</p>
                  )}
                </div>
                <ArrowLeft className="size-4 text-gray-300 group-hover:text-blue-400 transition-colors rotate-180 shrink-0" />
              </Link>
            ))
          )}
        </div>
      </div>
    </div>
  )
}
